const TASK_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  SUCCESS: 'success',
  FAILED: 'failed',
  SKIPPED: 'skipped',
};

const TASK_TYPE = {
  SCHEDULED: 'scheduled',
  EVENT: 'event',
};

const TASKS_CONCURRENCY_LIMIT = 1;
const TASK_MAX_TRIES = 3;

const CRON_JOB_MAX_DURATION_SEC = 240; // 4 minutes is the velo limit for a cron job run @see https://wix.slack.com/archives/C02T75TDG2C/p1747750017241869

module.exports = {
  TASK_STATUS,
  TASK_TYPE,
  TASKS_CONCURRENCY_LIMIT,
  TASK_MAX_TRIES,
  CRON_JOB_MAX_DURATION_SEC,
};
